import videojs from "video.js";
import { Button } from './button.js';
import { Popup } from './popup.js';

const Plugin = videojs.getPlugin('plugin');

/**
 * @typedef {Object} Defaults
 */

/** @type {Defaults} */
const defaults = {};

/**
 * @class
 * @extends videojs.getPlugin('plugin')
 */
class SettingsGroup extends Plugin {
	/**
	 * @constructor
	 * @param {videojs.Player} player - The video player instance.
	 * @param {Options} options - The options for the SettingsGroup plugin.
	 */
	constructor(player, options) {
		super(player);
		this.options = videojs.mergeOptions({}, defaults, options);

		this.isReady = false;
		this.title = 'Settings';
		this.toggleButton = null;
		this.popup = null;

		this.player.ready(() => {
			this.addToggleButton();
			this.addPopup();

			this.isReady = true;
			this.trigger('settingsGroup/ready');
		});
	}

	addPopup() {
		const popup = new Popup(this.player, {
			className: 'vjs-settings-group__popup',
			onHide: () => {
				if (this.toggleButton) {
					this.toggleButton.turnOff();
				}
			},
			onShow: () => {
				if (this.toggleButton) {
					this.toggleButton.turnOn();
				}
			}
		});
		this.popup = this.player.addChild(popup);
	}

	addToggleButton() {
		const controlBar = this.player.getChild('controlBar');
		if (!controlBar) return;

		const spacer = controlBar.getChild('customControlSpacer');
		let insertionIndex = controlBar.children().length;
		if (spacer) {
			insertionIndex = controlBar.children().indexOf(spacer) + 1;
		}
		const toggleButton = new Button(
			this.player,
			{
				controlText: this.title,
				className: 'vjs-settings-group__button',
				clickHandler: () => {
					if (this.popup) {
						this.popup.toggle();
					}
				}
			}
		);
		this.toggleButton = controlBar.addChild(toggleButton, {}, insertionIndex);
	}

	addSettingsSection({ name, getCurrentValue, items, id, isHidden, componentName }) {
		const [
			updateSettingsListComponent,
			getSettingsListComponent
		] = this.popup.addSettingsList(items, isHidden);
		const [
			updateNameComponent,
			getSettingsNameComponent
		] = this.popup.addSettingsName(id, name, getCurrentValue, getSettingsListComponent, componentName);
		return {
			update() {
				updateSettingsListComponent();
				updateNameComponent();
			},
			dispose() {
				const settingsListComponent = getSettingsListComponent();
				let isHiddenSettingsListComponent = true;
				if (!settingsListComponent.isDisposed()) {
					isHiddenSettingsListComponent = settingsListComponent.hasClass('vjs-hidden');
					settingsListComponent.dispose();
				}
				getSettingsNameComponent().dispose();
				return {
					wasHidden: isHiddenSettingsListComponent
				};
			}
		};
	}
}

videojs.registerPlugin('settingsGroup', SettingsGroup);
